import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	heading: {
		id: 'freeTrialPlans.header.title',
		defaultMessage: 'Choose Plan',
		description: 'Heading for Plans hero',
	},
});
